module.exports = __webpack_public_path__ + "static/media/snappy-laptop.f54716e6.svg";